const PUSH_TO_TALK_EXEMPT_TAGS = new Set([
  'a',
  'button',
  'input',
  'select',
  'textarea',
]);
const PUSH_TO_TALK_EXEMPT_ROLES = new Set([
  'button',
  'combobox',
  'link',
  'listbox',
  'menuitem',
  'option',
  'textbox',
]);

type KeyboardTargetLike = {
  tagName?: unknown;
  isContentEditable?: unknown;
  getAttribute?: unknown;
};

export function isPushToTalkKeyboardTargetExempt(
  target: EventTarget | KeyboardTargetLike | null
): boolean {
  if (!target || typeof target !== 'object') return false;
  const candidate = target as KeyboardTargetLike;
  if (candidate.isContentEditable === true) return true;

  const tagName =
    typeof candidate.tagName === 'string'
      ? candidate.tagName.toLowerCase()
      : '';
  if (PUSH_TO_TALK_EXEMPT_TAGS.has(tagName)) return true;

  if (typeof candidate.getAttribute === 'function') {
    const role = candidate.getAttribute('role');
    return (
      typeof role === 'string' &&
      PUSH_TO_TALK_EXEMPT_ROLES.has(role.toLowerCase())
    );
  }

  return false;
}
